export default __webpack_public_path__ + "static/okonomiamatorene_3-2f2bbd5bfa1d7704316a42efe4eeeb99.jpg";